import { combineReducers } from 'redux';
import userReducer from 'shared/reducers/userReducer';
import screenReducer from 'shared/reducers/screenReducer';
import modalReducer from 'shared/reducers/modalReducer';
import kioskReducer from 'app/reducers/kioskReducer';
import cartReducer from 'shared/reducers/cartReducer';
import photoSwipeReducer from 'app/reducers/photoSwipeReducer';
import datePickerReducer from 'shared/reducers/datePickerReducer';
import messagesReducer from 'shared/reducers/messagesReducer';
import stripeReducer from 'shared/reducers/stripeReducer';

export default combineReducers({
  userReducer,
  screenReducer,
  modalReducer,
  kioskReducer,
  cartReducer,
  photoSwipeReducer,
  datePickerReducer,
  messagesReducer,
  stripeReducer
});
